export const jfpPerfFeatureFlags = [] as const;
